import React, { forwardRef, memo } from 'react'

const BookShape = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="310.8"
      height="352.1"
      viewBox="0 0 310.8 352.1"
      fill="none"
      {...props}>
      <path
        d="M184.202 23.927c-.973-6.517-7.044-11.011-13.561-10.038L11.8 37.61c-6.516.973-11.01 7.044-10.037 13.561l43.104 288.64c.973 6.517 7.044 11.011 13.561 10.038l158.843-23.721c6.517-.973 11.011-7.044 10.038-13.561L184.202 23.927Z"
        fill="#4D7F0E"
      />
      <path
        d="M184.202 23.927c-.973-6.516-7.044-11.01-13.561-10.038L21.33 36.187c-5.765.861-9.74 6.232-8.879 11.997l43.51 291.361c.861 5.764 6.232 9.74 11.997 8.879l149.311-22.296c6.517-.973 11.011-7.044 10.038-13.561L184.202 23.927Z"
        fill="#78BE20"
      />
      <rect
        width="156.932"
        height="297.804"
        rx="7.801"
        transform="matrix(-.989.148.148.989 175.898 24.24)"
        fill="#99D6EA"
      />
      <path
        d="m90.299 203.922 73.477-11.02 12.605 82.265-73.478 11.02-12.604-82.265Z"
        fill="#78BE20"
      />
      <path
        d="m82.749 186.499 82.247-12.285 2.728 18.146-82.246 12.285-2.729-18.146Z"
        fill="#397615"
      />
      <path
        d="M123.481 180.647c1.582-13.879 14.447-21.504 17.521-15.799 3.726 6.978-6.783 13.999-17.521 15.799Zm0 0c-10.932-7.379-10.77-24.234-4.689-26.206 9.868-3.594 11.435 22.165 4.689 26.206Zm0 0c-11.023 3.145-24.825-5.642-21.893-11.386 5.263-10.248 21.89 11.143 21.893 11.386Z"
        stroke="#6C0CAE"
        strokeWidth="1.129"
      />
      <path
        d="m126.672 199.329.826 17.392 20.242 18.406 15.645-17.206-20.242-18.406-16.471-.186Z"
        fill="#fff"
      />
      <circle
        cx="177.859"
        cy="89.027"
        r="23.333"
        transform="rotate(-3.262 177.859 89.027)"
        fill="#D15A19"
      />
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="154"
        y="65"
        width="48"
        height="48">
        <circle
          cx="177.859"
          cy="89.027"
          r="23.333"
          transform="rotate(-3.262 177.859 89.027)"
          fill="#C27C00"
        />
      </mask>
      <g mask="url(#mask0)" stroke="#fff" strokeWidth="1.025">
        <path d="m155.983 79.226 10.235-.584" />
        <path d="m159.488 104.696 10.235-.584" />
        <path d="m151.623 92.823 12.794-.73" />
      </g>
      <ellipse
        cx="182.214"
        cy="89.026"
        rx="21.529"
        ry="23.579"
        transform="rotate(-3.262 182.214 89.026)"
        fill="#FFA300"
      />
      <circle
        cx="217.137"
        cy="173.689"
        r="33.285"
        transform="rotate(6.014 217.137 173.689)"
        fill="#D15A19"
      />
      <mask
        id="mask1"
        maskUnits="userSpaceOnUse"
        x="183"
        y="139"
        width="66"
        height="66">
        <circle
          cx="217.137"
          cy="173.689"
          r="33.285"
          transform="rotate(6.014 217.137 173.689)"
          fill="#C27C00"
        />
      </mask>
      <g mask="url(#mask1)" stroke="#fff" strokeWidth="1.462">
        <path d="m187.409 154.861 13.728 1.532" />
        <path d="m186.454 191.528 13.729 1.533" />
        <path d="m177.329 172.887 18.18 2.03" />
      </g>
      <ellipse
        cx="223.268"
        cy="174.69"
        rx="30.712"
        ry="33.637"
        transform="rotate(6.014 223.268 174.69)"
        fill="#FFA300"
      />
      <circle
        cx="242.569"
        cy="106.289"
        r="27.542"
        transform="rotate(6.014 242.569 106.289)"
        fill="#D15A19"
      />
      <mask
        id="mask2"
        maskUnits="userSpaceOnUse"
        x="215"
        y="78"
        width="55"
        height="56">
        <circle
          cx="242.569"
          cy="106.289"
          r="27.542"
          transform="rotate(6.014 242.569 106.289)"
          fill="#C27C00"
        />
      </mask>
      <g mask="url(#mask2)" stroke="#fff" strokeWidth="1.21">
        <path d="m218.95 90.169 12.116 1.268" />
        <path d="m218.186 120.509 12.116 1.268" />
        <path d="m210.809 105.18 15.518 1.585" />
      </g>
      <ellipse
        cx="248.009"
        cy="107.224"
        rx="25.413"
        ry="27.834"
        transform="rotate(6.014 248.009 107.224)"
        fill="#FFA300"
      />
    </svg>
  )
)

BookShape.displayName = 'BookShape'

export default memo(BookShape)
